//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return{
      domain:''
    }
  },
  mounted() {
    this.finaceList()
  },
  methods:{
    async submit() {
      let data = 'cmd=domain_bind'+
        '&cmd_type=add'+
        '&id='+ this.$route.params.id +
        '&domainname='+ this.domain
      let _this = this
      this.$http.post('https://api.abeiyun.com/www/vhost.php',data).then(({data})=>{
        if(data.response == 200 ) {
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
            onHide () {
              _this.$router.push('/user/domainname/'+_this.$route.params.id)
            }
          })
        }else{
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/console/hostoperate/defaultsetadd.vue